import React, { Component } from 'react'
import styles from './pupil.styles'
import injectSheet from 'react-jss'
import PupilHead from './pupil-head/pupil-head.container'
import { Route } from 'react-router-dom'
import Profile from './profile/profile.container'
import Work from './work/work.container'
import Comments from './comments/comments.container'
import Assessment from './assessment/assessment.container'

class Pupil extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.onMount()
  }
  render() {
    return (
      <div>
        <PupilHead />
        <Route exact path="/pupil/:id" component={Profile} />
        <Route exact path="/pupil/:id/work" component={Work} />
        <Route exact path="/pupil/:id/comments" component={Comments} />
        <Route exact path="/pupil/:id/assessment" component={Assessment} />
      </div>
    )
  }
}

export default injectSheet(styles)(Pupil)
